module.exports = "/_next/static/images/24efe8ddbe07268834d0aeedc9c5dc0b-payment_delay_gray.png";